import api from './api';

export interface LogEntry {
  id: string;
  level: string;
  message: string;
  service?: string | null;
  timestamp?: string | null;
  context?: string | null;
  createdAt: string;
}

export interface LogsResponse {
  logs: LogEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface LogsParams {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  level?: string; // legacy single-level support (backend still understands this)
  levels?: string[];
  service?: string; // legacy single-service support
  services?: string[];
  search?: string;
  sortField?: 'timestamp' | 'level' | 'service' | 'createdAt';
  sortDirection?: 'asc' | 'desc';
}

export const logsApi = {
  getAll: async (params?: LogsParams): Promise<LogsResponse> => {
    // Normalize levels[] / services[] to comma-separated strings so the backend
    // can parse them reliably from req.query. Empty arrays are sent as "" so the
    // backend can treat them as match-nothing (vs omitted = no filter).
    const query: Record<string, unknown> = { ...(params || {}) };

    if (params?.levels !== undefined) {
      query.levels = params.levels.join(',');
    } else {
      delete query.levels;
    }

    if (params?.services !== undefined) {
      query.services = params.services.join(',');
    } else {
      delete query.services;
    }

    const { data } = await api.get('/logs', { params: query });
    return data;
  },
};

